import Booking from '../../../models/booking'

export default function getName(booking: Booking) {
    const name = booking?.agency?.name || booking?.driver?.name || '-'
    const guideName = booking?.agency_guide?.name || ''
    return `${name} ${guideName ? `- ${guideName}` : ''}`
}
